import {
  GET_PRODUCTS_LIST,
  GET_PRODUCTS_LIST_SUCCESS,
  GET_PRODUCTS_LIST_FAIL,
  GET_SAME_PRODUCTS,
  GET_SAME_PRODUCTS_SUCCESS,
  GET_SAME_PRODUCTS_FAIL,
  GET_RETAILERS_LIST,
  GET_RETAILERS_LIST_SUCCESS,
  GET_RETAILERS_LIST_FAIL,
  GET_RETAILERS_LIST_V2,
  GET_RETAILERS_LIST_V2_SUCCESS,
  GET_RETAILERS_LIST_V2_FAIL,
  GET_OCR_RETAILERS_LIST,
  GET_OCR_RETAILERS_LIST_SUCCESS,
  GET_OCR_RETAILERS_LIST_FAIL,
  GET_PRICES,
  GET_PRICES_SUCCESS,
  GET_PRICES_FAIL,
  ADD_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  SEARCH_STORE_ID,
  SEARCH_STORE_ID_SUCCESS,
  SEARCH_STORE_ID_FAIL,
  ADD_PRODUCT_FAIL,
  UPDATE_SAME_PRODUCT,
  UPDATE_SAME_PRODUCT_SUCCESS,
  UPDATE_SAME_PRODUCT_FAIL,
  SEARCH_GTIN,
  SEARCH_GTIN_SUCCESS,
  SEARCH_GTIN_FAIL,
  DELETE_PRODUCT,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAIL,
  GET_RETAILER_BRANDS,
  GET_RETAILER_BRANDS_SUCCESS,
  GET_RETAILER_BRANDS_FAIL,
  SET_CURRENT_RETAILER,
  UPDATE_PRICE,
  UPDATE_PRICE_SUCCESS,
  UPDATE_PRICE_FAIL,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAIL,
  GET_PARTICIPANTS,
  GET_PARTICIPANTS_SUCCESS,
  GET_PARTICIPANTS_FAIL,
  SET_CHECKED_RETALER,
  CLEAR_GTIN_ERROR,
  EXPORT_PRODUCTS,
  EXPORT_PRODUCTS_SUCCESS,
  EXPORT_PRODUCTS_FAIL,
  GET_EXPORT_LINK,
  GET_EXPORT_LINK_SUCCESS,
  GET_EXPORT_LINK_FAIL,
  CLEAR_DOWNLOAD_LINK,
  IMPORT_PRODUCTS,
  IMPORT_PRODUCTS_SUCCESS,
  IMPORT_PRODUCTS_FAIL,
  GET_IMPORT_STATUS,
  GET_IMPORT_STATUS_SUCCESS,
  GET_IMPORT_STATUS_FAIL,
  IMPORT_SAME_PRODUCTS,
  IMPORT_SAME_PRODUCTS_SUCCESS,
  IMPORT_SAME_PRODUCTS_FAIL,
  ADD_PRICE,
  ADD_PRICE_SUCCESS,
  ADD_PRICE_FAIL,
  GET_SPG_LIST,
  GET_SPG_LIST_SUCCESS,
  GET_SPG_LIST_FAIL,
  PAM_SET_ITEM_VALUE
} from './actions'
import { initialState } from './selectors'

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_PRODUCTS_LIST:
      return {
        ...state,
        isLoadingProducts: true,
        isSuccessUpdatedProduct: false,
        deletingRetailerId: null,
        isUpdatedImport: false
      }
    case GET_PRODUCTS_LIST_SUCCESS:
      return {
        ...state,
        isLoadingProducts: false,
        products: payload && payload.result,
        countProducts: payload && payload.products_count
      }
    case GET_PRODUCTS_LIST_FAIL:
      return {
        ...state,
        isLoadingProducts: false
      }
    case GET_RETAILERS_LIST:
      return {
        ...state,
        isLoadingRetailers: true
      }
    case GET_RETAILERS_LIST_SUCCESS:
      return {
        ...state,
        isLoadingRetailers: false,
        retailers: payload,
        currentRetailer: payload && payload[0] && payload[0].participant_id
      }
    case GET_RETAILERS_LIST_FAIL:
      return {
        ...state,
        isLoadingRetailers: false
      }
    case GET_RETAILERS_LIST_V2:
      return {
        ...state,
        isLoadingRetailers: true
      }
    case GET_RETAILERS_LIST_V2_SUCCESS:
      return {
        ...state,
        isLoadingRetailers: false,
        retailers: payload
        // currentRetailer: payload && payload[0] && payload[0].participant_id
      }
    case GET_RETAILERS_LIST_V2_FAIL:
      return {
        ...state,
        isLoadingRetailers: false
      }
    case GET_OCR_RETAILERS_LIST:
      return {
        ...state,
        isLoadingOCRRetailer: true
      }
    case GET_OCR_RETAILERS_LIST_SUCCESS:
      return {
        ...state,
        isLoadingOCRRetailer: false,
        ocrRetailers: payload,
        currentOCRRetailer: payload && payload[0] && payload[0].participant_id
      }
    case GET_OCR_RETAILERS_LIST_FAIL:
      return {
        ...state,
        isLoadingOCRRetailer: false
      }
    case GET_SAME_PRODUCTS:
      return {
        ...state,
        currentProductId: payload && payload.id,
        currentStoreId: payload && payload.store_id,
        currentGtin: payload && payload.gtin,
        isLoadingPricesOrSames: true
      }
    case GET_SAME_PRODUCTS_SUCCESS:
      return {
        ...state,
        isLoadingPricesOrSames: false,
        sameProducts: payload
      }
    case GET_SAME_PRODUCTS_FAIL:
      return {
        ...state,
        isLoadingPricesOrSames: false
      }
    case GET_PRICES:
      return {
        ...state,
        isLoadingPricesOrSames: true,
        currentProductId: payload
      }
    case GET_PRICES_SUCCESS:
      return {
        ...state,
        isLoadingPricesOrSames: false,
        prices: payload.prices,
        historicalPrices: payload.history,
        isUpdatePriceSuccess: true
      }
    case GET_PRICES_FAIL:
      return {
        ...state,
        isLoadingPricesOrSames: false
      }
    case ADD_PRODUCT:
      return {
        ...state,
        isUpdatedProduct: true,
        isSuccessUpdatedProduct: false,
        isGtinError: false
      }
    case ADD_PRODUCT_SUCCESS:
      return {
        ...state,
        isUpdatedProduct: false,
        isSuccessUpdatedProduct: true,
        isGtinError: false
      }
    case ADD_PRODUCT_FAIL:
      return {
        ...state,
        isUpdatedProduct: false,
        isSuccessUpdatedProduct: false,
        isGtinError: payload
      }
    case UPDATE_PRODUCT:
      return {
        ...state,
        isUpdatedProduct: true,
        isSuccessUpdatedProduct: false,
        isGtinError: false
      }
    case UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        isUpdatedProduct: false,
        isSuccessUpdatedProduct: true,
        isGtinError: false
      }
    case UPDATE_PRODUCT_FAIL:
      return {
        ...state,
        isUpdatedProduct: false,
        isSuccessUpdatedProduct: false,
        isGtinError: payload
      }
    case DELETE_PRODUCT:
      return {
        ...state,
        isPrdouctDeleting: true
      }
    case DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        isPrdouctDeleting: false
      }
    case DELETE_PRODUCT_FAIL:
      return {
        ...state,
        isPrdouctDeleting: false
      }
    case UPDATE_SAME_PRODUCT:
      return {
        ...state,
        isUpdatedSameProduct: true
      }
    case UPDATE_SAME_PRODUCT_SUCCESS:
      return {
        ...state,
        isUpdatedSameProduct: false
      }
    case UPDATE_SAME_PRODUCT_FAIL:
      return {
        ...state,
        isUpdatedSameProduct: false
      }
    case SEARCH_GTIN:
      return {
        ...state,
        isLoadingGtins: true
      }
    case SEARCH_GTIN_SUCCESS:
      return {
        ...state,
        isLoadingGtins: false,
        gtins: payload
      }
    case SEARCH_GTIN_FAIL:
      return {
        ...state,
        isLoadingGtins: false
      }
    case GET_RETAILER_BRANDS:
      return {
        ...state,
        isLoadingBrands: true
      }
    case GET_RETAILER_BRANDS_SUCCESS:
      return {
        ...state,
        retailerBrands: payload,
        isLoadingBrands: false
      }
    case GET_RETAILER_BRANDS_FAIL:
      return {
        ...state,
        isLoadingBrands: false
      }
    case SET_CURRENT_RETAILER:
      return {
        ...state,
        currentRetailer: payload,
        retailerBrands: null,
        sameProducts: null,
        prices: null,
        currentProductId: null
      }
    case UPDATE_PRICE: {
      return {
        ...state,
        isLoadingPricesOrSames: true,
        isUpdatePriceSuccess: false
      }
    }
    case UPDATE_PRICE_SUCCESS: {
      return {
        ...state,
        isLoadingPricesOrSames: false
      }
    }
    case UPDATE_PRICE_FAIL: {
      return {
        ...state,
        isLoadingPricesOrSames: false,
        isUpdatePriceSuccess: false
      }
    }
    case GET_PARTICIPANTS:
      return {
        ...state,
        isLoadingParticipants: true
      }
    case GET_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        participants: payload,
        isLoadingParticipants: false
      }
    case GET_PARTICIPANTS_FAIL:
      return {
        ...state,
        participants: payload,
        isLoadingParticipants: false
      }
    case SET_CHECKED_RETALER:
      return {
        ...state,
        currRetailer: payload,
        deletingRetailerId: payload
      }
    case CLEAR_GTIN_ERROR:
      return {
        ...state,
        isGtinError: false
      }
    case EXPORT_PRODUCTS:
      return {
        ...state,
        exportLink: null
      }
    case EXPORT_PRODUCTS_SUCCESS:
      return {
        ...state,
        exportLink: payload
      }
    case EXPORT_PRODUCTS_FAIL:
      return {
        ...state,
        exportLink: null
      }
    case GET_EXPORT_LINK:
      return {
        ...state,
        downloadLink: null
      }
    case GET_EXPORT_LINK_SUCCESS:
      return {
        ...state,
        exportLink: null,
        downloadLink: payload
      }
    case GET_EXPORT_LINK_FAIL:
      return {
        ...state,
        downloadLink: null
      }
    case GET_IMPORT_STATUS:
      return {
        ...state
      }
    case GET_IMPORT_STATUS_SUCCESS:
      return {
        ...state,
        importLink: payload && payload.import,
        importSameLink: payload && payload.importSame
      }
    case GET_IMPORT_STATUS_FAIL:
      return {
        ...state,
        importLink: null,
        importSameLink: null
      }
    case CLEAR_DOWNLOAD_LINK:
      return {
        ...state,
        downloadLink: null
      }
    case IMPORT_PRODUCTS:
      return {
        ...state,
        isLoadingImport: true,
        isUpdatedImport: false,
        importLink: null
      }
    case IMPORT_PRODUCTS_SUCCESS:
      return {
        ...state,
        isLoadingImport: false,
        isUpdatedImport: true,
        importLink: payload
      }
    case IMPORT_PRODUCTS_FAIL:
      return {
        ...state,
        isLoadingImport: false,
        isUpdatedImport: false
      }
    case IMPORT_SAME_PRODUCTS:
      return {
        ...state,
        isLoadingSameImport: true,
        isUpdatedSameImport: false,
        importSameLink: null
      }
    case IMPORT_SAME_PRODUCTS_SUCCESS:
      return {
        ...state,
        isLoadingSameImport: false,
        isUpdatedSameImport: true,
        importSameLink: payload
      }
    case IMPORT_SAME_PRODUCTS_FAIL:
      return {
        ...state,
        isLoadingSameImport: false,
        isUpdatedSameImport: false
      }
    case ADD_PRICE:
      return {
        ...state,
        isLoadingPricesOrSames: true
      }
    case ADD_PRICE_SUCCESS:
      return {
        ...state,
        isLoadingPricesOrSames: false
      }
    case ADD_PRICE_FAIL:
      return {
        ...state,
        isLoadingPricesOrSames: false
      }
    case SEARCH_STORE_ID:
      return {
        ...state,
        isLoadingStoreIds: true
      }
    case SEARCH_STORE_ID_SUCCESS:
      return {
        ...state,
        isLoadingStoreIds: false,
        storeIds: payload
      }
    case SEARCH_STORE_ID_FAIL:
      return {
        ...state,
        isLoadingStoreIds: false
      }
    case GET_SPG_LIST:
      return {
        ...state,
        isLoading: true,
        isUpdated: false,
        isImported: false,
        isExported: false
      }
    case GET_SPG_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        products: payload && payload.result,
        totalItems: payload && payload.result && payload.result.length
      }
    case GET_SPG_LIST_FAIL:
      return {
        ...state,
        isLoading: false
      }
    case PAM_SET_ITEM_VALUE:
      return {
        ...state,
        [payload.name]: payload.value
      }
    default:
      return state
  }
}
